import React from 'react';
import ReactDOM from 'react-dom';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
// Vendored MDB build carrying the p4cloud-skin theme (navy buttons etc.) that App applies via
// the `p4cloud-skin` class; the mdbreact package ships the stock mdb.css, which lacks that skin.
import './styles/mdb.css';
import './index.css';
import App from './App';

//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

ReactDOM.render( <App /> , document.getElementById('root'));

//registerServiceWorker();
unregister();
